import AsyncStorage from "@react-native-async-storage/async-storage";
import axios from "axios";
import {endpoints} from "@api/apis";

export const showEditLimitAPICall = async (payload: {
    applicationId: string;
}) => {
    const applicationIdStored = await AsyncStorage.getItem("application_id")
    const applicationId = applicationIdStored ?? payload.applicationId
    return await axios.get(`${endpoints.showEditLimit}${applicationId}`);

}

export const editLimitAPICall = async (payload: {
    applicationId: string;
}) => {
    const applicationIdStored = await AsyncStorage.getItem("application_id")
    const applicationId = applicationIdStored ?? payload.applicationId
    return await axios.get(`${endpoints.editLimit}${applicationId}`);

}

export const getEnabledRTA = async (payload: {
    applicationId: string;
}) => {
    const applicationIdStored = await AsyncStorage.getItem("application_id");
    const applicationId = applicationIdStored ?? payload.applicationId;
    const response = await axios.get(`${endpoints.checkEnabledRTA}${applicationId}`);
    return response.data;
}

export const getNextStepId = async (payload: {
    applicationId: string;
}) => {
    const applicationIdStored = await AsyncStorage.getItem("application_id")
    const applicationId = applicationIdStored ?? payload.applicationId
    const updatedApplicationResponse = await axios.get(endpoints.borrowerApplication + applicationId);
    return updatedApplicationResponse?.data;

}
